<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="40%"
      title="教练可服务时间"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px" :rules="rules" ref="timeForm">
        <el-form-item label="星期" >
          <el-select v-model="weeks" placeholder="请选择星期" multiple style="width: 100%">
            <el-option label="周日" value="0"></el-option>
            <el-option label="周一" value="1"></el-option>
            <el-option label="周二" value="2"></el-option>
            <el-option label="周三" value="3"></el-option>
            <el-option label="周四" value="4"></el-option>
            <el-option label="周五" value="5"></el-option>
            <el-option label="周六" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" prop="times_range" required>
          <el-input 
            v-model="form.times_range" 
            placeholder="请输入时间段，格式如：08:00-12:00,14:00-18:00"
          ></el-input>
          <div style="color: #999; font-size: 12px; margin-top: 5px;">
            提示：多个时间段用逗号分隔，例如：08:00-12:00,14:00-18:00
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="status" required>
          <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
            <el-option label="可用" :value="1"></el-option>
            <el-option label="停用" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()">修 改</el-button>
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ObjectChangedValue } from "@/js/utils";

export default {
  data() {
    return {
      weeks: [],
      form: {
        coach_id: this.$route.query.coach_id || null,
        weeks: null,
        times_range: '',
        status: 1
      },
      temp: {},
      rules: {
        weeks: [
          { required: true, message: '请选择星期', trigger: 'change' }
        ],
        times_range: [
          { required: true, message: '请输入时间段', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      dialogVisible: false
    };
  },

  methods: {
    open(info) {
      if (info && info.id) {
        // 编辑模式
        this.temp = Object.assign({}, info);
        this.form = Object.assign({}, info);
        this.weeks = info.weeks.split(',')
      } else {
        // 新增模式
        this.form = {
          coach_id: this.$route.query.id || null,
          times_range: '',
          status: 1
        };
        this.temp = {};
      }
      this.dialogVisible = true;
      // 重置表单验证
      this.$nextTick(() => {
        if (this.$refs.timeForm) {
          this.$refs.timeForm.clearValidate();
        }
      });
    },
    updateForm() {
      this.$refs.timeForm.validate((valid) => {
        if (valid) {
          this.updateService();
        }
      });
    },
    submitForm() {
      this.$refs.timeForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
       this.form.weeks = this.weeks.join(",");
      let url = "/user/coachTimes/insert";
      
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "success", message: "添加成功!" });
        this.dialogVisible = false;
        this.form = {
          coach_id: this.$route.query.id || null,
          weeks: null,
          times_range: '',
          status: 1
        };
        this.$emit("success");
      });
    },
    updateService() {
      this.form.weeks = this.weeks.join(",");
      let data = ObjectChangedValue(this.temp, this.form);
      data.id = this.form.id;
      let url = "/user/coachTimes/update";
      
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.dialogVisible = false;
        this.form = {
          coach_id: this.$route.query.id || null,
          times_range: '',
          status: 1
        };
        this.temp = {};
        this.$emit("success");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
